import { useMutation } from "urql";

import { DeleteLimitRequestExceptionDocument } from "../../../graphql/generated.ts";

export const useDeleteLimitRequestException = () =>
  useMutation(DeleteLimitRequestExceptionDocument);
